import { render, staticRenderFns } from "./s2_index.vue?vue&type=template&id=29fe5686&scoped=true&"
import script from "./s2_index.vue?vue&type=script&lang=js&"
export * from "./s2_index.vue?vue&type=script&lang=js&"
import style0 from "./s2_index.vue?vue&type=style&index=0&id=29fe5686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe5686",
  null
  
)

export default component.exports